import React from 'react';
import { HashRouter as Router, Switch, Route, } from "react-router-dom";
import './App.css';
import Profile from './Profile';
import PrivateRoute from './auth/PrivateRoute';
import { ApplicationPaths } from './auth/constants';
import AuthRoutes from './auth/AuthRoutes';
import Home from './Home';
function App() {
    return (React.createElement(Router, null,
        React.createElement(Switch, null,
            React.createElement(Route, { exact: true, path: "/", component: Home }),
            React.createElement(PrivateRoute, { exact: true, path: "/profile", component: Profile }),
            React.createElement(Route, { path: ApplicationPaths.AuthorizationPrefix, component: AuthRoutes }))));
}
export default App;
